var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('challenge',{attrs:{"title":"診断テスト","offset":0,"contents":[_vm.contents[0]]}})}
var staticRenderFns = []

export { render, staticRenderFns }